import { motion } from 'framer-motion';
import { TbAlertOctagonFilled } from 'react-icons/tb';
import { tableRowAnimVariants } from '../../constants/animationVariants';

const NoTableDataFound = ({
  message,
  disableAnim,
}: {
  message: string;
  disableAnim?: boolean;
}) => {
  // rendering no table data found
  return (
    <motion.div
      variants={disableAnim ? undefined : tableRowAnimVariants}
      initial='hidden'
      animate='visible'
      className='flex items-center justify-center my-5'
    >
      <div className='flex items-center justify-center gap-2 text-base-red bg-base-white border-2 border-base-red px-5 py-3 rounded-xl'>
        <TbAlertOctagonFilled className='size-6' />
        <p className='capitalize text-lg'>{message}</p>
      </div>
    </motion.div>
  );
};

export default NoTableDataFound;
